export default "__VITE_ASSET__B6rFReGu__"